module.exports = __webpack_public_path__ + "static/media/Jocelyn.84d30c14.jpg";